import { useTranslation } from 'react-i18next';

import FlagUk from 'components/Icons/FlagUk';
import FlagGerman from 'components/Icons/FlagGerman';

import './LanguageMenu.scoped.scss';

const LanguageMenu = () => {
  const {
    i18n: { changeLanguage, language: currentLanguageCode },
  } = useTranslation('login');

  const handleLanguageChange = code => () => {
    changeLanguage(code);
    window.localStorage.setItem('lang', code);
  };

  return (
    <div className="language-menu">
      <div className="option" onClick={handleLanguageChange('de')}>
        <div className="radio">
          <input
            type="radio"
            value="de"
            name="German"
            checked={currentLanguageCode === 'de'}
            onChange={() => null}
          />
          <div className="dot" />
        </div>
        <FlagGerman fontSize={28} /> German
      </div>

      <div className="option" onClick={handleLanguageChange('en')}>
        <div className="radio">
          <input
            type="radio"
            value="en"
            name="English"
            checked={currentLanguageCode === 'en'}
            onChange={() => null}
          />
          <div className="dot" />
        </div>
        <FlagUk fontSize={28} /> English
      </div>
    </div>
  );
};

export default LanguageMenu;
